const wooFiltersInner = document.querySelector('#woo-filters-inner')
if (wooFiltersInner) {
    const headings = wooFiltersInner.querySelectorAll('.woo-widget-title')
    const uls = wooFiltersInner.querySelectorAll('.woocommerce-widget-layered-nav-list')
    headings.forEach((heading) => heading.classList.add('dp'))
    uls.forEach((ul) => ul.classList.add('ds'))
}

// VISA OCH GÖM FILTER
document.addEventListener('click', function (e) {
    if (e.target.matches('.woo-filter-btn')) {
        if (document.body.classList.contains('filter-active')) {
            document.body.classList.remove('filter-active')
        } else {
            document.body.classList.add('filter-active')
        }
    }
    if (e.target.matches('#woo-filters-overlay, .close-filter')) {
        document.body.classList.remove('filter-active')
    }

    if (e.target.matches('.language-card .filter-item')) {
        document.querySelector('.overlay').classList.remove('d-none')
        document.querySelector('.dc-loader-nohide').classList.add('active')
    }
})
;(function ($) {
    document.body.addEventListener('click', function (e) {
        if (e.target.matches('.woocommerce-widget-layered-nav-list__item a')) {
            // Ändrar URL:en utan att ladda om sidan
            window.history.pushState({}, null, e.target.href)
            e.preventDefault()

            $('#woo-filters-inner, #products-loop-wrapper').addClass('hide')

            $('#woo-filters-inner-wrapper').load(
                e.target.href + ' ' + '#woo-filters-inner',
                function (responseTxt, statusTxt, jqXHR) {
                    $('#woo-filters-inner').removeClass('hide')
                }
            )

            $('#products-loop-wrapper').load(
                e.target.href + ' ' + '#products-loop',
                function (responseTxt, statusTxt, jqXHR) {
                    $('#products-loop-wrapper').removeClass('hide')
                }
            )
        }
    })
})(jQuery)

// SOURCE:  https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_filter_elements
// filterSelection("all")
// function filterSelection(c) {
//   var x, i;
//   x = document.getElementsByClassName("filterDiv");
//   if (c == "all") c = "";
//   // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
//   for (i = 0; i < x.length; i++) {
//     RemoveClass(x[i], "show");
//     if (x[i].className.indexOf(c) > -1) AddClass(x[i], "show");
//   }
// }

// // Show filtered elements
// function AddClass(element, name) {
//   var i, arr1, arr2;
//   arr1 = element.className.split(" ");
//   arr2 = name.split(" ");
//   for (i = 0; i < arr2.length; i++) {
//     if (arr1.indexOf(arr2[i]) == -1) {
//       element.className += " " + arr2[i];
//     }
//   }
// }

// // Hide elements that are not selected
// function RemoveClass(element, name) {
//   var i, arr1, arr2;
//   arr1 = element.className.split(" ");
//   arr2 = name.split(" ");
//   for (i = 0; i < arr2.length; i++) {
//     while (arr1.indexOf(arr2[i]) > -1) {
//       arr1.splice(arr1.indexOf(arr2[i]), 1);
//     }
//   }
//   element.className = arr1.join(" ");
// }

// document.body.addEventListener('click', function(e){
//     if( e.target.matches('.woocommerce-widget-layered-nav-list__item a') ){
//         displayMatches(e);
//     }
// });
